"use strict";
/* globals module */
/**
 * @module mediaVaultProcessingProviderSettingsClient
 * @description  Media Vault Processing Provider Settings Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Vault Processing Provider Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var MediaVaultProcessingProviderSettingsClient = /** @class */ (function () {
    function MediaVaultProcessingProviderSettingsClient(mediaVaultProcessingProviderSettingsRoute, apiClient) {
        this.mediaVaultProcessingProviderSettingsRoute = mediaVaultProcessingProviderSettingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MediaVaultProcessingProviderSettingsClient.prototype, "routeDefinition", {
        get: function () {
            return this.mediaVaultProcessingProviderSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of media vault processing providers matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example mediaVaultProcessingProviderSettingsClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    MediaVaultProcessingProviderSettingsClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the media vault processing provider resource.
     * @method
     * @param id Preprocessing provider id which uniquely identifies preprocessing provider whose settings need to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example mediaVaultProcessingProviderSettingsClient.get('<id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MediaVaultProcessingProviderSettingsClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.mediaVaultProcessingProviderSettingsRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates a media vault processing provider setting resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `mediaVaultProcessingProviderSettingsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(processingProviderSetting);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A media vault preprocessing provider settings object used to update specified media vault preprocessing provider settings in the system.
     * @returns A promise that is resolved once the update action has been performed.
     * @example // processingProviderSettings is a resource previously fetched using get action.
                    processingProviderSettings.settings.faceDetection = true;
                    mediaVaultProcessingProviderSettingsClient.update(processingProviderSetting)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    MediaVaultProcessingProviderSettingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    MediaVaultProcessingProviderSettingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MediaVaultProcessingProviderSettingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MediaVaultProcessingProviderSettingsRoute !== "undefined" && _1.MediaVaultProcessingProviderSettingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MediaVaultProcessingProviderSettingsClient);
    return MediaVaultProcessingProviderSettingsClient;
}());
exports.MediaVaultProcessingProviderSettingsClient = MediaVaultProcessingProviderSettingsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
